<template>
  <div class="register_title">
   {{title}}
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '标题'
        },
  },
}
</script>

<style lang="scss" scoped>
.register_title{
    width: 100%;
    background: #F5F5F5;
    height: 44px;
    line-height: 44px;
    padding:0 20px;
    font-size: 18px;
    color: #333333;
}
</style>